export const AlternativeType = {
  PROGRAM: 'program',
  AVAILABILITY: 'availability',
  BINDING_TIME: 'binding_time',
};
